
class DataLayerCart {

  constructor() {
    this.storage = window.localStorage
  }

  /** Return a "primary category" based on the given ticket info. */
  getTicketPrimaryCategory(title, attributeIds) {
    if (attributeIds.includes("42")) return 'HOTEL'
    if (title.toLowerCase().includes('express pass')) return 'UEP' // Taken from US site
    if (attributeIds.includes("5")) return 'TICKET_DATED_FUTURE' // Taken from US site
    return 'TICKET'
  }

  getNumCartViews() {
    const numCartViews = this?.storage?.getItem('numCartViews')
    return numCartViews ? parseInt(numCartViews) : 0
  }

  getLastCartViewDate() {
    const lastCartViewDate = this?.storage?.getItem('lastCartViewDate')
    return lastCartViewDate ? new Date(lastCartViewDate) : undefined
  }

}

export const dataLayerCart = new DataLayerCart()


